import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Calendar from "../calendar/Calendar";
import Footer from "../components/Footer";
import Header from "../components/Header";
import UserList from "../components/UserList";
import { useAuthCheck } from "../util/utils";
import { useAuth } from "../context/AuthContext";

const HomeComponent = ({ api }) => {

  const navigate = useNavigate()
  const [currentDate, setCurrentDate] = useState(new Date());
  const { token } = useAuth()
  const [birthdayMap, setBirthdayMap] = useState({})
  const [birthdayUsers, setBirthdayUsers] = useState([]);
  const [birthdaysToday, setBirthdaysToday] = useState([]);

  // map of day : [user]
  const [birthdayCalendar, setBirthdayCalendar] = useState({});

  useAuthCheck()

  useEffect(() => {
    (async () => {
      if (token) {
        try {
          let resp = await api().listBirthdaysForMonth(token)
          if (resp.status === 200) {
            setBirthdayMap(resp.data)
          }
        } catch (e) { }
      }
    })()
  }, [token])

  useEffect(() => {
    (async () => {
      const birthdays = {}
      const todayBirthdays = []
      let formattedUsers = []

      if (birthdayMap && birthdayMap[currentDate.getMonth() + 1]) {
        formattedUsers = birthdayMap[currentDate.getMonth() + 1].map((birthday) => {

          let name, username
          if (birthday.type === "FOLLOW") {
            name = `${birthday.other.firstName} ${birthday.other.lastName}`
            username = birthday.other.username
          } else if (birthday.type === "CUSTOM") {
            name = birthday.label
          }
          const { month, day } = birthday
          const birthdayDate = `${month}/${day}`;

          const birthdayUser = {
            id: birthday._id,
            name: name,
            username: username,
            caption: birthdayDate,
            other: birthday.other
          }

          if (birthdays[day]) {
            birthdays[day].push(birthdayUser)
          } else {
            birthdays[day] = [birthdayUser]
          }

          if (new Date().getMonth() + 1 == month && new Date().getDate() == day) {
            todayBirthdays.push(birthdayUser)
          }

          return birthdayUser;
        });
      }

      setBirthdaysToday(todayBirthdays)
      setBirthdayCalendar(birthdays)
      setBirthdayUsers(formattedUsers)
      
    })()
  }, [birthdayMap, currentDate])

  return (
    <div className="bg-gradient-to-b from-blue-400 to-green-700 pt-10 flex flex-col text-white min-h-screen">
      {/* Calendar Section */}
      <div className="pt-10 overflow-auto flex items-center justify-center">
        <Calendar
          api={api}
          currentDate={currentDate}
          setCurrentDate={setCurrentDate}
          currentMonthBirthdays={birthdayCalendar}
        />
      </div>

      {/* Birthdays List Section */}
      <div className="md:w-1/2 w-full p-4 mt-4 overflow-auto mx-auto">
        {birthdaysToday.length > 0 && <div className="pb-6"><h2 className="text-2xl font-bold">Birthdays today</h2>
          <UserList users={birthdaysToday} />
        </div>}
        <h2 className="text-2xl font-bold">Birthdays this month!</h2>
        <UserList users={birthdayUsers} />
        {(birthdayUsers.length == 0 &&
          <div className="flex flex-col items-center justify-center text-center p-6 ">
            <h2 className="text-xl font-semibold ">You have no upcoming birthdays this month</h2>
            <p className="mt-2">
              Find users by <span className="text-blue-300 hover:underline cursor-pointer" onClick={() => navigate("/users/search")}>searching</span>, or click on a date on the calendar to add someone.
            </p>
          </div>)
        }
      </div>
    </div>
  );
}

const Home = ({ api }) => (
  <div>
    <Header api={api} />
    <HomeComponent api={api} />
    <Footer />
  </div>
)
export default Home;